export type EventoReconexaoJukebox = 'visibilitychange' | 'pageshow' | 'online' | 'focus';
export type EstadoVisibilidadeJukebox = 'visible' | 'hidden';

export function deveReconectarJukebox(
  evento: EventoReconexaoJukebox,
  visibilidade: EstadoVisibilidadeJukebox,
): boolean {
  if (visibilidade !== 'visible') return false;
  return evento === 'visibilitychange' || evento === 'pageshow' || evento === 'online' || evento === 'focus';
}
